export default __webpack_public_path__ + "static/media/to_do.757033f4.svg";